import React from 'react';
import { useActiveBreakpoint } from './hooks/useActiveBreakpoint';
// For now using a placeholder image - replace with actual Figma asset
import familyWellbeingImage from '../assets/family-financial-wellbeing-best-planning-for-your-family.jpg';

function ImageFamilyFinancialWellbeingDesktop() {
  return (
    <div className="relative rounded-[10px] shrink-0 w-full lg:w-[587px] h-auto lg:h-[720px] lg:[grid-area:1_/_1]" data-name="Image (Family Financial Wellbeing)">
      <img alt="Family Financial Wellbeing" className="w-[60%] h-auto lg:h-full object-contain lg:object-cover pointer-events-none rounded-[10px]" src={familyWellbeingImage} />
    </div>
  );
}

function Heading1Desktop() {
  return (
    <div className="relative h-auto lg:absolute lg:h-[64px] lg:left-0 lg:top-0 w-full lg:w-[354px] mb-4 lg:mb-0" data-name="Heading 1">
      <p className="font-['Inter:Bold',sans-serif] font-bold leading-[32px] not-italic text-[20px] md:text-[24px] text-black tracking-[0.0703px]">Family Financial Wellbeing – Best Planning for your Family</p>
    </div>
  );
}

function ContainerDesktop() {
  return (
    <div className="relative h-auto lg:absolute lg:h-[28px] lg:left-0 lg:top-[72px] w-full lg:w-[354px] mb-4 lg:mb-0" data-name="Container">
      <p className="font-['Inter:Bold',sans-serif] font-bold leading-[28px] not-italic text-[20px] text-black text-nowrap tracking-[-0.4492px] whitespace-pre">£65.00 – £75.00</p>
    </div>
  );
}

function ParagraphDesktop() {
  return (
    <div className="relative h-auto lg:absolute lg:h-[288px] lg:left-0 lg:right-0 lg:top-[116px] mb-4 lg:mb-0" data-name="Paragraph">
      <p className="font-['Inter:Regular',sans-serif] font-normal leading-[24px] not-italic text-[16px] text-black tracking-[-0.3125px]">
        Family Financial Wellbeing Support offers personalized guidance to help families achieve financial stability and security. This service provides expert advice on budgeting, saving, debt management, and long-term financial planning. Whether you're dealing with financial challenges or looking to build a secure future, our tailored support will help you make informed decisions and achieve your goals. Empower your family with the tools and knowledge to thrive financially, ensuring peace of mind and a prosperous future for generations to come.
      </p>
    </div>
  );
}

function LabelDesktop() {
  return (
    <div className="h-[24px] relative shrink-0 w-full" data-name="Label">
      <p className="absolute font-['Inter:Bold',sans-serif] font-bold leading-[24px] left-0 not-italic text-[16px] text-black text-nowrap top-0 tracking-[-0.3125px] whitespace-pre">Choose An Option:</p>
    </div>
  );
}

function DropdownDesktop() {
  return (
    <div className="h-[46px] relative rounded-[4px] shrink-0 w-full" data-name="Dropdown">
      <div aria-hidden="true" className="absolute border border-[#d1d5dc] border-solid inset-0 pointer-events-none rounded-[4px]" />
      <select className="absolute inset-0 w-full h-full bg-transparent border-none outline-none px-3">
        <option>Option 1 - Employment Solution</option>
        <option>Option 2 - Financial Education</option>
        <option>Option 3 - Income Opportunity</option>
        <option>Option 4 - Entrepreneurship Scheme</option>
        <option>Option 5 - Personalised Financial Plan</option>
        <option>Option 6 - Debt Management Solution</option>
        <option>Option 7 - Debt Management Plan</option>
        <option>Option 8 - Individual Voluntary Arrangement</option>
        <option>Option 9 - UK Financial Claims</option>
      </select>
    </div>
  );
}

function ContainerDesktop1() {
  return (
    <div className="relative lg:absolute content-stretch flex flex-col gap-[8px] h-[78px] items-start lg:left-0 lg:top-[428px] w-full lg:w-[354px] mb-4 lg:mb-0" data-name="Container">
      <LabelDesktop />
      <DropdownDesktop />
    </div>
  );
}

function LabelDesktop1() {
  return (
    <div className="h-[24px] relative shrink-0 w-full" data-name="Label">
      <p className="absolute font-['Inter:Bold',sans-serif] font-bold leading-[24px] left-0 not-italic text-[16px] text-black text-nowrap top-0 tracking-[-0.3125px] whitespace-pre">Choose A Time:</p>
    </div>
  );
}

function DropdownDesktop1() {
  return (
    <div className="h-[46px] relative rounded-[4px] shrink-0 w-full" data-name="Dropdown">
      <div aria-hidden="true" className="absolute border border-[#d1d5dc] border-solid inset-0 pointer-events-none rounded-[4px]" />
      <select className="absolute inset-0 w-full h-full bg-transparent border-none outline-none px-3">
        <option>9:00 AM - 10:00 AM</option>
        <option>10:00 AM - 11:00 AM</option>
        <option>2:00 PM - 3:00 PM</option>
        <option>3:00 PM - 4:00 PM</option>
      </select>
    </div>
  );
}

function ContainerDesktop2() {
  return (
    <div className="relative lg:absolute content-stretch flex flex-col gap-[8px] h-[78px] items-start lg:left-0 lg:top-[522px] w-full lg:w-[354px] mb-4 lg:mb-0" data-name="Container">
      <LabelDesktop1 />
      <DropdownDesktop1 />
    </div>
  );
}

function ButtonDesktop() {
  return (
    <button className="h-[46px] w-[40.781px] bg-transparent border-0 cursor-pointer" data-name="Button">
      <p className="font-['Inter:Regular',sans-serif] font-normal leading-[28px] text-[20px] text-black tracking-[-0.4492px]">-</p>
    </button>
  );
}

function TextDesktop() {
  return (
    <div className="relative shrink-0 size-[40px]" data-name="Text">
      <p className="absolute font-['Inter:Regular',sans-serif] font-normal leading-[24px] left-[50%] text-[16px] text-black text-center top-[8px] tracking-[-0.3125px] translate-x-[-50%]">1</p>
    </div>
  );
}

function ButtonDesktop1() {
  return (
    <button className="basis-0 grow h-[46px] min-h-px min-w-px bg-transparent border-0 cursor-pointer" data-name="Button">
      <p className="font-['Inter:Regular',sans-serif] font-normal leading-[28px] text-[20px] text-black tracking-[-0.4492px]">+</p>
    </button>
  );
}

function ContainerDesktop3() {
  return (
    <div className="relative lg:absolute box-border content-stretch flex h-[48px] items-center lg:left-0 p-px rounded-[4px] lg:top-0 w-[126.812px]" data-name="Container">
      <div aria-hidden="true" className="absolute border border-[#d1d5dc] border-solid inset-0 pointer-events-none rounded-[4px]" />
      <ButtonDesktop />
      <TextDesktop />
      <ButtonDesktop1 />
    </div>
  );
}

function ButtonDesktop2() {
  return (
    <button className="relative lg:absolute bg-black h-[48px] lg:left-[142.81px] rounded-[4px] lg:top-0 w-full lg:w-[131.031px] border-0 cursor-pointer mt-4 lg:mt-0" data-name="Button">
      <p className="font-['Inter:Regular',sans-serif] font-normal leading-[24px] text-[16px] text-white tracking-[-0.3125px]">Add to Cart</p>
    </button>
  );
}

function ContainerDesktop4() {
  return (
    <div className="relative lg:absolute h-auto lg:h-[48px] lg:left-0 lg:top-[624px] w-full lg:w-[354px] mb-4 lg:mb-0 flex flex-col lg:flex-row gap-4 lg:gap-0" data-name="Container">
      <ContainerDesktop3 />
      <ButtonDesktop2 />
    </div>
  );
}

function LinkDesktop() {
  return (
    <div className="relative lg:absolute h-[24px] lg:left-0 lg:top-0 w-auto lg:w-[66.234px]" data-name="Link">
      <button className="bg-transparent border-0 cursor-pointer p-0">
        <p className="font-['Inter:Regular',sans-serif] font-normal leading-[24px] text-[16px] text-black tracking-[-0.3125px]">Compare</p>
      </button>
    </div>
  );
}

function LinkDesktop1() {
  return (
    <div className="relative lg:absolute h-[24px] lg:left-[90.23px] lg:top-0 w-auto lg:w-[105.672px]" data-name="Link">
      <button className="bg-transparent border-0 cursor-pointer p-0">
        <p className="font-['Inter:Regular',sans-serif] font-normal leading-[24px] text-[16px] text-black tracking-[-0.3125px]">Add to wishlist</p>
      </button>
    </div>
  );
}

function ContainerDesktop5() {
  return (
    <div className="relative lg:absolute h-auto lg:h-[24px] lg:left-0 lg:top-[696px] w-full lg:w-[354px] flex flex-col lg:flex-row gap-4 lg:gap-0" data-name="Container">
      <LinkDesktop />
      <LinkDesktop1 />
    </div>
  );
}

function ContainerDesktop7() {
  return (
    <div className="relative shrink-0 w-full lg:w-[738px] px-4 lg:px-0 lg:[grid-area:1_/_2]" data-name="Container">
      <Heading1Desktop />
      <ContainerDesktop />
      <ParagraphDesktop />
      <ContainerDesktop1 />
      <ContainerDesktop2 />
      <ContainerDesktop4 />
      <ContainerDesktop5 />
    </div>
  );
}

function ContainerDesktop8() {
  return (
    <div className="gap-[32px] grid grid-cols-1 lg:grid-cols-[repeat(2,_minmax(0px,_1fr))] grid-rows-auto lg:grid-rows-[repeat(1,_minmax(0px,_1fr))] h-auto lg:h-[849px] relative shrink-0 w-full px-4 lg:px-0" data-name="Container">
      <ImageFamilyFinancialWellbeingDesktop />
      <ContainerDesktop7 />
    </div>
  );
}

// Service Options Data
const serviceOptions = [
  {
    title: "Option 1",
    description: "Employment solution: Help for families to assess their employment needs to enable them make informed choices on job search and job creation or acquire employment skills and tools. *Fee payment, waiver or deferment depends on personal circumstances, so contact us."
  },
  {
    title: "Option 2", 
    description: "Financial education: Help for families to assess their level of financial education to enable them make informed choices.*Fee payment, waiver or deferment depends on personal circumstances, so contact us."
  },
  {
    title: "Option 3",
    description: "Income opportunity and business start-up:Help for families to assess income opportunity and business start-up to enable them make informed choices.*Fee payment, waiver or deferment depends on personal circumstances, so contact us."
  },
  {
    title: "Option 4",
    description: "Entrepreneurship Scheme for Families: Innovation and entrepreneurship training for family's members in small and medium family business enterprises.*Fee payment, waiver or deferment depends on personal circumstances, so contact us."
  },
  {
    title: "Option 5",
    description: "Personalised Financial Plan (PFP): A report put together with you to assist you in deciding most relevant solutions for your family financial future. Some firms charge you £450 to £900*Fee payment, waiver or deferment depends on personal circumstances, so contact us."
  },
  {
    title: "Option 6",
    description: "Debt Management Solution: Overview of the family's current financial status and financial education to enable them pick the best debt freedom plan.*Fee payment, waiver or deferment depends on personal circumstances, so contact us."
  },
  {
    title: "Option 7",
    description: "Debt Management Plan (DMP): A written plan put together with you to assist you in deciding best debt freedom plan.*Fee payment, waiver or deferment depends on personal circumstances, so contact us."
  },
  {
    title: "Option 8",
    description: "Individual Voluntary Arrangement(IVA) for Debt Management: Incurs standard fees but with our partners you will not pay anything until you enter into a solution.*Fee payment, waiver or deferment depends on personal circumstances, so contact us."
  },
  {
    title: "Option 9",
    description: "UK Financial Claims Management: To recover families' well-deserved money back from miss-sold packaged bank accounts and PPI products.*Fee payment, waiver or deferment depends on personal circumstances, so contact us."
  },
  {
    title: "Option 10",
    description: "Mortgage Solutions: From leading mortgage networks that offers exclusive rates which we enable us to hand the savings to families.*Fee payment, waiver or deferment depends on personal circumstances, so contact us."
  },
  {
    title: "Option 11",
    description: "Accounting and Tax Solutions: Help with tax returns, budgeting etc.*Fee payment, waiver or deferment depends on personal circumstances, so contact us."
  }
];

function ServiceOptionsDesktop() {
  return (
    <div className="w-full max-w-4xl mx-auto px-4">
      <h2 className="font-['Inter:Bold',sans-serif] font-bold leading-[28px] text-[20px] text-black tracking-[-0.4492px] mb-8">
        Family Financial Wellbeing – Best Planning for your Family
      </h2>
      
      <div className="space-y-6">
        {serviceOptions.map((option, index) => (
          <div key={index} className="border-b border-gray-200 pb-6">
            <div className="grid grid-cols-[173px_1fr] gap-6">
              <div>
                <p className="font-['Inter:Medium',sans-serif] font-medium leading-[24px] text-[16px] text-black tracking-[-0.3125px]">
                  {option.title}
                </p>
              </div>
              <div>
                <p className="font-['Inter:Regular',sans-serif] font-normal leading-[24px] text-[16px] text-black tracking-[-0.3125px]">
                  {option.description}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-12 space-y-4">
        <p className="font-['Inter:Regular',sans-serif] font-normal leading-[24px] text-[16px] text-black tracking-[-0.3125px]">
          Enrolling in the "Family Financial Wellbeing" guide is a crucial step toward securing your family's financial future. This guide provides tailored strategies to help you effectively manage finances, reduce debt, and build savings. By following the expert advice within, you can achieve long-term stability and peace of mind.
        </p>
        
        <div className="mt-8">
          <h3 className="font-['Inter:Bold',sans-serif] font-bold leading-[28px] text-[18px] text-black tracking-[-0.4395px] mb-4">
            Benefits to grab:
          </h3>
          <ul className="space-y-2 pl-5">
            <li className="font-['Inter:Regular',sans-serif] font-normal leading-[24px] text-[16px] text-black tracking-[-0.3125px]">
              Personalized budgeting tips for your family's needs.
            </li>
            <li className="font-['Inter:Regular',sans-serif] font-normal leading-[24px] text-[16px] text-black tracking-[-0.3125px]">
              Strategies to eliminate debt and increase savings.
            </li>
            <li className="font-['Inter:Regular',sans-serif] font-normal leading-[24px] text-[16px] text-black tracking-[-0.3125px]">
              Insights into financial planning for education and retirement.
            </li>
            <li className="font-['Inter:Regular',sans-serif] font-normal leading-[24px] text-[16px] text-black tracking-[-0.3125px]">
              Tools to manage unexpected expenses.
            </li>
            <li className="font-['Inter:Regular',sans-serif] font-normal leading-[24px] text-[16px] text-black tracking-[-0.3125px]">
              Guidance on creating a sustainable financial plan for the future.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

// Simplified responsive versions for tablet and mobile
function FamilyFinancialWellbeingTablet() {
  return (
    <div className="bg-white min-h-screen p-4">
      <div className="max-w-2xl mx-auto">
        <ContainerDesktop8 />
        <div className="mt-8">
          <ServiceOptionsDesktop />
        </div>
      </div>
    </div>
  );
}

function FamilyFinancialWellbeingMobile() {
  return (
    <div className="bg-white min-h-screen p-4">
      <div className="max-w-sm mx-auto">
        <div className="mb-6">
          <img alt="Family Financial Wellbeing" className="w-full h-48 object-cover rounded-lg mb-4" src={familyWellbeingImage} />
          <h1 className="font-['Inter:Bold',sans-serif] font-bold text-xl text-black mb-2">
            Family Financial Wellbeing – Best Planning for your Family
          </h1>
          <p className="font-['Inter:Bold',sans-serif] font-bold text-lg text-black mb-4">
            £65.00 – £75.00
          </p>
          <p className="font-['Inter:Regular',sans-serif] text-sm text-black leading-relaxed mb-6">
            Family Financial Wellbeing Support offers personalized guidance to help families achieve financial stability and security.
          </p>
        </div>
        <ServiceOptionsDesktop />
      </div>
    </div>
  );
}

function FamilyFinancialWellbeingDesktop() {
  return (
    <div className="bg-white min-h-screen">
      <div className="max-w-7xl mx-auto px-4 py-8">
        <ContainerDesktop8 />
        <div className="mt-12">
          <ServiceOptionsDesktop />
        </div>
      </div>
    </div>
  );
}

export default function FamilyFinancialWellbeing() {
  return (
    <div className="bg-white min-h-screen">
      <div className="max-w-7xl mx-auto px-4 py-8">
        <ContainerDesktop8 />
        <div className="mt-12">
          <ServiceOptionsDesktop />
        </div>
      </div>
    </div>
  );
}